import { create } from "zustand";
import { devtools } from "zustand/middleware";

const useStore = create(
  devtools((set) => ({
    loggedIn: localStorage.getItem("loginLab101") === "true" ? true : false,
    setLoggedIn: (loggedIn: boolean) => {
      localStorage.setItem("loginLab101", loggedIn ? "true" : "false");
      set(() => ({ loggedIn: loggedIn }));
    },
    user: localStorage.getItem("userLab101")
      ? JSON.parse(localStorage.getItem("userLab101")!)
      : null,
    setUser: (user: { name: string; password: string; admin: boolean }) => {
      localStorage.setItem("userLab101", JSON.stringify(user));
      set(() => ({ user: user }));
    },
  }))
);

export default useStore;
